import ActivateAccount from "../../components/activate-account-panel/activate-account.component";

export default function ActivationPage(){
    return <ActivateAccount/>
}